module.exports = __webpack_public_path__ + "static/media/logo_and_text.70287fb9.png";